<template>
  <div class="admin-shell">
    <TopBar />
    <main class="admin-main">
      <div class="admin-content">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import TopBar from '@/components/navigation/TopBar.vue';

export default {
  name: 'AdminLayout',
  components: { TopBar },
};
</script>

<style lang="scss" scoped>
.admin-shell {
  min-height: 100vh;
  background: #f5f6f8;
}

.admin-main {
  min-height: 100vh;
  margin-left: 248px;
  padding: 32px;
}

.admin-content {
  width: 100%;
  padding: 28px;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 18px;
  box-shadow: 0 8px 28px rgba(31, 35, 48, 0.06);
}

@media (max-width: 1599.98px) and (min-width: 992px) {
  .admin-main {
    margin-left: 216px;
    padding: 24px;
  }

  .admin-content {
    padding: 24px;
  }
}

@media (max-width: 991.98px) {
  .admin-main {
    margin-left: 84px;
    padding: 20px;
  }

  .admin-content {
    padding: 20px;
    border-radius: 14px;
  }
}
</style>
